import { Button, Form, Header, Segment, TextArea } from '@mairistem/composants';
import type React from 'react';

type EditeurContenuProps = {
  texte: string;
  loading: boolean;
  textareaRef: React.MutableRefObject<any>;
  onChange: (e: any, data: { value: string }) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onRetourDefaut: () => void;
};

const EditeurContenu = (props: EditeurContenuProps) => {
  const { texte, loading, textareaRef, onChange, onBlur, onRetourDefaut } = props;

  return (
    <Segment basic style={{ padding: 0 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '1em',
          height: 30,
        }}
      >
        <Header as="h4" style={{ margin: 0 }}>
          Éditeur du contenu
        </Header>
        <Button
          data-testid="button-retour-defaut"
          basic
          size="tiny"
          icon="undo"
          content="Revenir au modèle par défaut"
          onClick={onRetourDefaut}
          disabled={loading}
          floated="right"
        />
      </div>

      <div
        ref={(ref) => {
          // recupère le textarea dans la div pour le donner en ref à textareaRef
          // obligé de faire ça car le TextArea
          // de jvs-mairistem-composants ou SUIR marche pas avec la ref
          if (ref) {
            const textarea = ref.getElementsByTagName('textarea')[0];
            if (textareaRef && textareaRef.current !== textarea) {
              textareaRef.current = textarea;
            }
          }
        }}
        style={{ height: 450 }}
      >
        <Form.Field
          // @ts-expect-error
          style={{ height: '100%' }}
        >
          <TextArea
            data-testid="textarea-texte-relance"
            value={texte}
            onChange={onChange}
            onBlur={onBlur}
            placeholder="Saisissez le texte des relances..."
            disabled={loading}
            style={{
              height: '100%',
              padding: '1cm',
              resize: 'none',
              fontFamily: 'Arial, sans-serif',
            }}
          />
        </Form.Field>
      </div>
    </Segment>
  );
};

export default EditeurContenu;
